import React, { useEffect, useState } from "react";
import { clipSummary, subscribeClipState } from "utils/clipRegistry";
import { ReadoutSC } from "./styled";

/**
 * How the folder's voicings stand on THIS machine.
 *
 * Preparing a clip costs very different amounts of time on different computers, and until now the
 * editor said nothing about it at all — so "it lags for me" was the whole of what a translator
 * could report, and there was no way to tell a slow machine from a broken file from a bug. This is
 * one line they can read out: how many voicings are ready, and how long the slowest one took.
 *
 * Cheap to keep current: it re-reads the summary on clip transitions, which are bounded by the
 * prefetch window, and it renders a single line of text.
 */
export const ClipReadout: React.FC = () => {
    const [summary, setSummary] = useState(clipSummary);

    useEffect(() => {
        setSummary(clipSummary());
        return subscribeClipState(() => setSummary(clipSummary()));
    }, []);

    if (!summary.total) return null;

    const slowest = summary.slowestMs
        ? ` · самая долгая ${(summary.slowestMs / 1000).toFixed(1).replace(".", ",")} с`
        : "";

    return (
        <ReadoutSC
            title={
                "Сколько озвучек готово к воспроизведению прямо сейчас. Готовятся заранее, " +
                "по ходу воспроизведения; если цифра сильно отстаёт — этой машине не хватает " +
                "скорости, и об этом стоит сообщить."
            }
        >
            Озвучки: {summary.ready}/{summary.total} готовы{slowest}
        </ReadoutSC>
    );
};
